import { Flex } from '@dynatrace/strato-components/layouts';

import { BodyRow } from './BodyRow.js';
import type { XYChartAxisBaseProps } from '../../../types/xy-chart.js';

/**
 * @internal
 */
export interface XYChartTooltipBodyProps {
  xAxisLabel?: XYChartAxisBaseProps['label'];
  yAxisLabel?: XYChartAxisBaseProps['label'];
  xAxisValue: string;
  yAxisValue: string;
  xAxisDuration?: string;
  yAxisDuration?: string;
}

/**
 * Defines the template for the XYChart tooltip body
 * @internal
 */
export function XYChartTooltipBody({
  xAxisLabel,
  yAxisLabel,
  xAxisValue,
  yAxisValue,
  xAxisDuration,
  yAxisDuration,
}: XYChartTooltipBodyProps) {
  return (
    <Flex flexDirection="column" gap={2}>
      <BodyRow
        axisId={xAxisLabel ? xAxisLabel : 'X-value'}
        text={xAxisValue}
        duration={xAxisDuration}
      />
      <BodyRow
        axisId={yAxisLabel ? yAxisLabel : 'Y-value'}
        text={yAxisValue}
        duration={yAxisDuration}
      />
    </Flex>
  );
}

(
  XYChartTooltipBody as typeof XYChartTooltipBody & { displayName: string }
).displayName = 'XYChartTooltipBody';
